import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { ThemeService } from '../../service/components/theme.service';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NgbTooltipModule],
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.css'],
})
export class AuthLayoutComponent implements OnInit {
  isDarkMode = false;

  constructor(
    private themeService: ThemeService,
    tooltipConfig: NgbTooltipConfig
  ) {
    // Configuración global de tooltips
    tooltipConfig.autoClose = true;
    tooltipConfig.triggers = 'hover';
    tooltipConfig.openDelay = 0;
    tooltipConfig.closeDelay = 0;
  }

  ngOnInit(): void {
    // Suscribirse al estado del tema
    this.themeService.darkMode$.subscribe((isDark) => {
      this.isDarkMode = isDark;
    });
  }

  /**
   * Cambia el modo de tema entre claro y oscuro
   */
  toggleDarkMode(): void {
    this.themeService.toggleDarkMode();
  }
}
